var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7893 5.27002C15.7937 5.27002 16.8433 5.5731 17.4118 6.3161C17.9829 7.06241 18.0256 8.20551 18.0256 9.86418V12.862C18.0256 14.7626 17.753 15.8605 17.1139 16.5329C16.4908 17.1886 15.5276 17.4561 13.7893 17.4561H6.51307C2.932 17.4561 2.27686 15.909 2.27686 12.862V9.86418C2.27686 8.29137 2.27686 7.15496 2.82903 6.38369C3.39537 5.59265 4.46273 5.27002 6.51307 5.27002H13.7893ZM9.08352 13.6756L12.3876 11.7769C12.5555 11.6805 12.6606 11.4894 12.6604 11.2811C12.6601 11.0729 12.5546 10.8821 12.3864 10.7862L9.08236 8.89976C8.92492 8.80983 8.73619 8.81675 8.58444 8.91808C8.43274 9.0194 8.34018 9.20038 8.34018 9.39543V13.1805C8.34018 13.3759 8.433 13.557 8.585 13.6583C8.66573 13.712 8.75686 13.7391 8.84821 13.7391C8.92888 13.7391 9.00966 13.718 9.08352 13.6756Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8c9f9b3cf1d78019d402d5b295520569.svg";
export { ForwardRef as ReactComponent };